module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor26-7c0822f2733acd40175927adc787eb05.jpg";